/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './NoAddressFound.scss';

import { func, object, string } from 'prop-types';
import React, { Fragment } from 'react';

import AddressDisplay from './AddressDisplay';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';

const AddressDisplayWithPermissions = WithUserPermissions(AddressDisplay);

const NoAddressFound = ({
  enteredAddress,
  name,
  onClose,
  onSelect,
  updatedContactInformation,
  hasResidential,
  isMailingSameAsResidential
}) => {
  const { residentialAddress, primaryMailingAddress } = updatedContactInformation;

  const handleSameAddressClick = () => {
    const residentialAddressWithDisposition = {
      ...residentialAddress,
      typeId: residentialAddress.typeId,
      contactId: residentialAddress.contactId,
      country: residentialAddress.country,
      disposition: {
        action: 'update'
      }
    };

    //If mailing is same as residential keep the mailing contactId and typeId but use residential address values
    const mailingAddressWithDisposition = {
      ...residentialAddress,
      typeId: primaryMailingAddress.typeId,
      contactId: primaryMailingAddress.contactId,
      disposition: {
        action: 'update'
      }
    };

    const contactInformation = {
      ...updatedContactInformation,
      primaryMailingAddress: mailingAddressWithDisposition,
      residentialAddress: residentialAddressWithDisposition
    };

    onSelect(contactInformation);
  };

  if(!hasResidential) {
    return <div className="no-address-found-container">
      <div className="header">
        The U.S. Postal service was unable to verify your mailing address.
      </div>
      <AddressDisplayWithPermissions
        address={enteredAddress}
        label="Address as entered"
        name={name}
        shouldMask
      />
      <div className="buttons">
        <button className="button" onClick={onClose}>
          Edit Address Info
        </button>
        <button
          className="button save-button"
          onClick={() => onSelect(updatedContactInformation)}>
          Use Entered Address Info
        </button>
      </div>
    </div>
  }

  return <Fragment>
    {hasResidential && isMailingSameAsResidential &&
      <div className="no-address-found-container">
        <div className="header">
          The U.S. Postal Service was unable to verify your address.
        </div>
        <AddressDisplayWithPermissions
          address={enteredAddress}
          label="Address as entered"
          name={name}
          shouldMask
        />
        <div className="buttons">
          <button className="button" onClick={onClose}>
            Edit Address Info
          </button>
          <button
            className="button save-button"
            onClick={() => handleSameAddressClick()}>
            Use Entered Address Info
          </button>
        </div>
      </div>
    }
    {hasResidential && !isMailingSameAsResidential &&
      <div className="no-address-found-container">
        {!enteredAddress.foreign && !primaryMailingAddress.foreign &&
          <div className="header">
            The U.S. Postal Service was unable to verify your residential/legal address & mailing address.
          </div>
        }
        {enteredAddress.foreign && !primaryMailingAddress.foreign &&
          <div className="header">
            The U.S. Postal Service was unable to verify your mailing address.
          </div>
        }
        {!enteredAddress.foreign && primaryMailingAddress.foreign &&
        <div className="header">
          The U.S. Postal Service was unable to verify your residential/legal address.
        </div>
        }
        {!enteredAddress.foreign &&
          <>
            <div className="address-type-label">
              Residential/Legal Address
            </div>
            <AddressDisplayWithPermissions
            address={enteredAddress}
            label="Address as entered"
            name={name}
            shouldMask
            />
          </>
        }
        {!primaryMailingAddress.foreign &&
          <>
            <div className="address-type-label">
              Mailing Address
            </div>
            <AddressDisplayWithPermissions
            address={primaryMailingAddress}
            label="Address as entered"
            name={name}
            shouldMask
            />
          </>
        }
        <div className="buttons">
          <button className="button" onClick={onClose}>
            Edit Address Info
          </button>
          <button
            className="button save-button"
            onClick={() => onSelect(updatedContactInformation)}>
            Use Entered Address Info
          </button>
        </div>
      </div>
    }
  </Fragment>
};

NoAddressFound.propTypes = {
  enteredAddress: object.isRequired,
  name: string.isRequired,
  onClose: func.isRequired,
  onSelect: func.isRequired
};

export default NoAddressFound;
